import { type ResponseItemType } from '@/common/types/response.type';
import Client from '@/common/utils/client.utility';
import { useQuery } from '@tanstack/react-query';

export interface ShopperTopMessageBarContent {
  message: string | null;
  backgroundColor: string | null;
  textColor: string | null;
}

export async function getShopperTopMessageBar(): Promise<
  ResponseItemType<ShopperTopMessageBarContent>
> {
  const client = new Client(true);
  return await client.get('/v1/TopMessageBar/Shopper/GetTopMessage');
}

export function useGetShopperTopMessageBar(enabled: boolean) {
  return useQuery<ResponseItemType<ShopperTopMessageBarContent>, Error>({
    queryKey: ['Shopper-Top-Message-Bar'],
    queryFn: getShopperTopMessageBar,
    enabled,
    staleTime: 600000,
  });
}
